import { ProductType } from '@inter-ikea-storageone/range';
import AccessoriesDrawersInfo from 'components/ProductSidebar/CategoryWidget/AccessoriesDrawersInfo';
import AccessoriesShelvesInfo from 'components/ProductSidebar/CategoryWidget/AccessoriesShelvesInfo';
import { ProductListConfig } from 'rangeConfig/@types';
import { addDrawerOrganizer } from 'rangeConfig/besta/behaviors/addDrawerOrganizer';
import { addShelfOrganizer } from 'rangeConfig/besta/behaviors/addShelfOrganizer';
import removeDrawerOrganizersInScene from 'rangeConfig/besta/behaviors/removeDrawerOrganizersInScene';
import removeShelfOrganizersInScene from 'rangeConfig/besta/behaviors/removeShelfOrganizersInScene';
import {
  matchShelfOrganizerToEntitesInScene,
  matchDrawerOrganizerToEntitesInScene
} from 'rangeConfig/besta/filters/mainMenuProductFilters';
import {
  noDrawerOrganizersInScene,
  noShelfOrganizersInScene
} from 'rangeConfig/besta/rules/noneOptionSelectedRules';
import { getAccessoryHoverImage } from 'rangeConfig/pax/rules/images';
import addProduct from 'rangeConfig/besta/behaviors/addProduct';

export const shelfAccessoryProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText',
  productCardHoverImage: getAccessoryHoverImage,
  behaviors: {
    productClicked: [addShelfOrganizer],
    productDropped: [addProduct]
  },
  productFilters: [matchShelfOrganizerToEntitesInScene],
  sortOrder: [{ path: 'name' }],
  cluster: [],
  categories: [
    {
      id: 'shelf-boxes',
      categoryTitle: 'storageone.productListAccessoriesCategoryShelvesTitle',
      cardsSubtitle: '',
      widgets: [{ component: AccessoriesShelvesInfo }],
      products: [
        { path: 'type', value: ProductType.BESTA_SHELF_ORGANIZER },
        { path: 'type', value: ProductType.BESTA_SHELF_AND_DRAWER_ORGANIZER }
      ],
      noneOption: {
        title: 'storageone.productListNoShelfOrganisersOptionTitle',
        subtitle: 'storageone.productListNoShelfOrganisersOptionSubtitle',
        behaviors: { removeProducts: [removeShelfOrganizersInScene] },
        selected: noShelfOrganizersInScene
      }
    }
  ]
};

export const drawerAccessoryProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText',
  productCardHoverImage: getAccessoryHoverImage,
  behaviors: {
    productClicked: [addDrawerOrganizer],
    productDropped: [addProduct]
  },
  productFilters: [matchDrawerOrganizerToEntitesInScene],
  sortOrder: [{ path: 'name' }],
  cluster: [],
  categories: [
    {
      id: 'drawer-boxes',
      categoryTitle: 'storageone.productListAccessoriesCategoryDrawersTitle',
      cardsSubtitle: '',
      widgets: [{ component: AccessoriesDrawersInfo }],
      products: [
        { path: 'type', value: ProductType.BESTA_DRAWER_ORGANIZER },
        { path: 'type', value: ProductType.BESTA_SHELF_AND_DRAWER_ORGANIZER }
      ],
      noneOption: {
        title: 'storageone.productListNoDrawerOrganisersOptionTitle',
        subtitle: 'storageone.productListNoDrawerOrganisersOptionSubtitle',
        behaviors: { removeProducts: [removeDrawerOrganizersInScene] },
        selected: noDrawerOrganizersInScene
      }
    }
  ]
};
